<svelte:options
  customElement={{
    tag: 'section-head',
    shadow: 'none',
    props: {
      caption: { type: 'String' },
      title: { type: 'String' },
      text: { type: 'String' },
      biz: { type: 'String' },
    },
  }}
/>
<script>
  import { onMount, tick } from 'svelte';
  import gsap from 'gsap';
  import { ScrollTrigger } from 'gsap/ScrollTrigger';

  // gsap.registerPluginはスクリプトのトップレベルで一度だけ実行するのがベストです
  gsap.registerPlugin(ScrollTrigger);

  const isBiz = $derived(biz === 'true' || biz === true);

  let {
    caption = '',
    title = '',
    text = '',
    biz = false
  } = $props();

  let h2Element;

  onMount(async () => {
    await tick(); // まずSvelteの更新を待つ

    if (h2Element) {
      const lettersSpan = h2Element.querySelector('.letters');
      if (lettersSpan) {
        // ...（<span class="letter">を生成する部分は変更なし）
        const parts = title.split(/(<br[^>]*>)/i);
        let processedHtml = '';
        parts.forEach((part) => {
          if (part.match(/<br[^>]*>/i)) {
            processedHtml += part;
          } else {
            const characters = part.split('').map(char => (char === ' ' ? '&nbsp;' : char));
            processedHtml += characters
              .map((char) => `<span class="letter">${char}</span>`)
              .join('');
          }
        });
        lettersSpan.innerHTML = processedHtml;

        // ✅ ここから：setTimeoutでGSAPの処理を囲む
        setTimeout(() => {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: h2Element,
              start: 'top 70%',
              // once: true もこの環境下で正しく機能するはずです
              once: true,
            },
          });

          if (isBiz) {
            tl.from(lettersSpan.querySelectorAll('.letter'), {
              rotationY: -80,
              opacity: 0,
              duration: 1.5,
              ease: 'expo.out',
              stagger: { each: 0.05, from: 'start' },
            });
          } else {
            tl.from(lettersSpan.querySelectorAll('.letter'), {
              y: 10,
              opacity: 0,
              duration: 1.5,
              ease: 'ease',
              stagger: { each: 0.08, from: 'start' },
            });
          }
        }, 100); // 0ミリ秒の遅延でも、実行タイミングが後回しになるため効果があります
      }
    }
  });
</script>

<div class={isBiz ? 'owd-biz-section-head' : 'spacing:bottom:40'} id="section-head">
  <div class="owd-sub spacing:bottom:16">
    <span class="owd-sub-marker"></span>
    <p class="owd-heading:en">{caption}</p>
  </div>

  <h2
    bind:this={h2Element}
    class={isBiz ? 'owd-heading:07 ' : ' owd-heading:02:large spacing:bottom:16'}
  >
    <span class="text-wrapper"><span class="letters"></span></span>
  </h2>

  {#if text.length}
    <p class="owd-text:01">{@html text}</p>
  {/if}
</div>

<style lang="scss">
  .owd-biz-section-head {
    margin-bottom: 64px;
    h2 {
      :global(.text-wrapper) {
        display: block;
        perspective: 500px;
        perspective-origin: 50% 50%;
      }
      :global(.letter) {
          display: inline-block;
          backface-visibility: hidden;
          transform-origin: left center;
          transform-style: preserve-3d;
      }
    }
    @include g.mobile {
      margin-bottom: 40px;
      h2 {
        @include g.owd-typography(
          $fz: 'heading-2-large',
          $line-height-px: 48,
          $letter-spacing-tracking: 25,
          $font-weight: 600
        );
        padding: 3.5px 0;
      }
    }
  }

  #section-head {
    :global(.letter) {
      display: inline-block;
    }
  }
</style>
